

export const DEBUG           = parseInt(process.env.REACT_APP_DEBUG || 0) === 1;

export const LEFT_MENU_WIDTH = 240;
export const CONVERSION_MODEL = {
    MANUAL: 'manual',
    FACTUAL: 'factual',
};